
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir35",
      function () {
        return require("private-next-pages/ir35/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir35"])
      });
    }
  